// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"4b07e719","48":"eb29e167","60":"e38dd8f9","320":"cf7b12b5","406":"5182780f","421":"06de76a9","826":"ed642316"}[chunkId] + ".chunk.js";
};